<template>
  <EditClientAffecter />
</template>

<script lang="ts">
  import { defineComponent } from "vue";

  
  import EditClientAffecter from "@/components/GesCom/ClientAffecter/EditClientAffecter.vue";

  export default defineComponent({
    name: "EditClientAffecterPage",
    components: {
      
      EditClientAffecter,
    },
  });
</script>